import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const addSnapshot = createAsyncThunk(
  "worker/snapshot",
  async (formData, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/snapshotStore`,
        formData,
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
    }
  }
);

const workerSnapshotSlice = createSlice({
    name: "workerSnapshotPlans",
    initialState: {
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder
        .addCase(addSnapshot.pending, (state) => {
                state.loading = true;
                state.error = null;
              })
              .addCase(addSnapshot.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload?.message || "Snapshot stored successfully";
              })
              .addCase(addSnapshot.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
              })
    },
});

export default workerSnapshotSlice.reducer;